module.exports = __webpack_public_path__ + "static/iexmh-5b55243f94b8888e28492da64b645371.jpg";